import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
import React from 'react';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';

class Warning extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  exitWarning = () => {
    this.setState({ open: false });
    this.props.onExitWarning();
  }

  render() {

    const { message, classes, title } = this.props;

    return (
      <Dialog data-test="warning-dialog" open={this.state.open} onClose={this.exitWarning} aria-labelledby="warning-dialog-title" >
        <DialogTitle disableTypography className={classes.mainHeading} id="warning-dialog-title">
          {title || "Something Went Wrong"} <WarningIcon style={{ float: 'right' }} fontSize="large" /></DialogTitle>
        <DialogContent>
          {Array.isArray(message) ?
            message.map((line, index) =>
              <DialogContentText
                key={index}
                className={classes.dialogText}
                paragraph>
                <span data-test={"warning-line-" + index} style={{ display: 'block' }}>{line}</span>
              </DialogContentText>
            )
            :
            <DialogContentText data-test={"warning-line"} className={classes.dialogText} paragraph>{
              message
            }
            </DialogContentText>
          }
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <PrimaryButton onClick={this.exitWarning}>Close</PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

Warning.propTypes = {
  title: PropTypes.string,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  classes: PropTypes.object,
  onExitWarning: PropTypes.func
};

export default withStyles(styles)(Warning);